import PhoneInput from "react-phone-input-2";

import styled from "styled-components";
export const PhoneNumberCountryStyled = styled(PhoneInput)`
  height: 54px;
  font-size: large !important;
  width: 100%;
  border-radius: 8px;
  .flag-dropdown {
    border-radius: 8px 0 0 8px;
    .selected-flag {
      background-color: inherit;
      border-radius: 8px 0 0 8px;
    }
  }
  .form-control {
    width: 100%;
    font-size: large !important;
    height: 54px;
    border: 1px solid rgba(49, 57, 73, 0.1);
    border-radius: 8px;
  }
  .background-red{
    background-color: tomato;
  }
`;

// export const MaskInputStyled = styled(MaskInput)`
//   border-radius: 8px;
//   border: 1px solid ${({ theme }) => theme.colors.border.grey};
//   box-sizing: border-box;
//   width: 100%;
//   color: ${({ theme }) => theme.colors.text.lightBlack};
//   padding: 16px 15px;
//   font-style: normal;
//   font-weight: normal;
//   font-size: 16px;
//   outline: none;
//   transition: all 300ms ease-out;
//   &:hover {
//     border-color: ${({ theme }) => theme.colors.border.grey};
//   }
//   &:focus {
//     border-color: ${({ theme }) => theme.colors.border.grey};
//   }
//   &::placeholder {
//     color: ${({ theme }) => theme.colors.text.lightBlack};
//   }
//   &:focus {
//     box-shadow: none;
//     color: #8b90a5;
//     border-color: #edf1ff;
//   }
//   &.error {
//     border-color: ${({ theme }) => theme.colors.border.red};
//   }
// `;
